import { cva } from 'class-variance-authority'

export const radioGroupVariants = cva([], {
  variants: {
    item: {
      base: [
        'relative',
        'inline-flex',
        'items-center',
        'justify-center',
        'w-6',
        'h-6',
        'rounded-full',
        'border',
        'border-carbon-500',
        'reading-dark:border-carbon-100',
        'data-[state=unchecked]:hover:border-[2px]',
        'data-[state=unchecked]:hover:border-blurple-300',
        'data-[state=unchecked]:active:border-blurple-300',
        'data-[state=unchecked]:active:bg-surface-hover',
        'data-[state=checked]:border-transparent',
        'data-[state=checked]:bg-surface-hover',
        'data-[state=checked]:hover:border-blurple-300',
        'data-[state=checked]:hover:border-[2px]',
        'dark:data-[state=checked]:bg-surface-hover',
        'outline-none',
        'cursor-pointer',
        'after:content-[""]',
        'after:block',
        'after:rounded-full',
        'after:w-0',
        'after:h-0',
        'after:bg-brand',
        'data-[state=unchecked]:active:after:w-3.5',
        'data-[state=unchecked]:active:after:h-3.5',
      ],
    },
    indicator: {
      base: [
        'flex',
        'items-center',
        'justify-center',
        'w-full',
        'h-full',
        'relative',
        'after:content-[\'\']',
        'after:block',
        'after:w-3.5',
        'after:h-3.5',
        'after:rounded-[50%]',
        'after:bg-brand',
        'dark:after:bg-brand',
      ],
    },
  },
})
